export interface ThemePreview {
  case: string;
  tube: string;
  ink: string;
}

export interface ThemeInfo {
  id: string;
  group: string;
  label: string;
  blurb: string;
  bar: string;
  barInk: string;
  tone: "dark" | "light";
  preview: ThemePreview;
  // only offered once this person has turned on mature options in Setup > Look
  mature?: boolean;
}

export const THEME_GROUPS = [
  { id: "signal", label: "signal" },
  { id: "sweet", label: "sweet" },
  { id: "nature", label: "nature" },
  { id: "edge", label: "edge" },
  { id: "retro", label: "retro" },
  { id: "otherworld", label: "otherworld" },
  { id: "y2k", label: "y2k" },
  { id: "mature", label: "mature" }
];

export const THEMES: ThemeInfo[] = [
  {
    id: "night",
    group: "signal",
    label: "night",
    blurb: "dark fog, film grain and chi's cyan",
    bar: "#06080d",
    barInk: "#4de8ff",
    tone: "dark",
    preview: { case: "#06080d", tube: "#4de8ff", ink: "#a4afc4" }
  },
  {
    id: "fog",
    group: "signal",
    label: "fog",
    blurb: "pale daytime fog, ink and deep teal",
    bar: "#cfd4dc",
    barInk: "#0c111c",
    tone: "light",
    preview: { case: "#cfd4dc", tube: "#0a7f9c", ink: "#0c111c" }
  },
  {
    id: "ember",
    group: "signal",
    label: "ember",
    blurb: "silent hill ash and an orange coal",
    bar: "#0c0907",
    barInk: "#ff8a3d",
    tone: "dark",
    preview: { case: "#0c0907", tube: "#ff8a3d", ink: "#b8aa9c" }
  },
  {
    id: "abyss",
    group: "signal",
    label: "abyss",
    blurb: "deep water, teal fog, a sonar ping",
    bar: "#030b10",
    barInk: "#3ef0d0",
    tone: "dark",
    preview: { case: "#030b10", tube: "#3ef0d0", ink: "#9cc0cb" }
  },
  {
    id: "petal",
    group: "sweet",
    label: "petal",
    blurb: "rose paper and a hot pink signal",
    bar: "#f3d9e3",
    barInk: "#2b1022",
    tone: "light",
    preview: { case: "#f3d9e3", tube: "#c21f68", ink: "#2b1022" }
  },
  {
    id: "peach",
    group: "sweet",
    label: "peach",
    blurb: "peach cream and a coral signal",
    bar: "#f7dccb",
    barInk: "#2a140c",
    tone: "light",
    preview: { case: "#f7dccb", tube: "#c0392b", ink: "#5e3a2c" }
  },
  {
    id: "mint",
    group: "sweet",
    label: "mint",
    blurb: "mint milk with strawberry pink",
    bar: "#d5efe3",
    barInk: "#0f2a20",
    tone: "light",
    preview: { case: "#d5efe3", tube: "#c42a65", ink: "#2f5446" }
  },
  {
    id: "lilac",
    group: "sweet",
    label: "lilac",
    blurb: "magical girl night, violet fog, bubblegum pink",
    bar: "#140b1f",
    barInk: "#ff94d1",
    tone: "dark",
    preview: { case: "#140b1f", tube: "#ff94d1", ink: "#c7b4dd" }
  },
  {
    id: "starlight",
    group: "sweet",
    label: "starlight",
    blurb: "midnight sky in periwinkle and pink",
    bar: "#0a0c1f",
    barInk: "#b8c4ff",
    tone: "dark",
    preview: { case: "#0a0c1f", tube: "#b8c4ff", ink: "#b4b8e0" }
  },
  {
    id: "sunset",
    group: "nature",
    label: "sunset",
    blurb: "dusk violet and a burnt orange sun",
    bar: "#150a1c",
    barInk: "#ff7a59",
    tone: "dark",
    preview: { case: "#150a1c", tube: "#ff7a59", ink: "#cfaeb4" }
  },
  {
    id: "forest",
    group: "nature",
    label: "forest",
    blurb: "moss, wet bark and leaf green",
    bar: "#07120c",
    barInk: "#8fe388",
    tone: "dark",
    preview: { case: "#07120c", tube: "#8fe388", ink: "#a7c0a2" }
  },
  {
    id: "coffee",
    group: "nature",
    label: "coffee",
    blurb: "espresso brown and crema",
    bar: "#130d09",
    barInk: "#e0a96d",
    tone: "dark",
    preview: { case: "#130d09", tube: "#e0a96d", ink: "#c2ab93" }
  },
  {
    id: "ice",
    group: "nature",
    label: "ice",
    blurb: "frozen pale blue and deep water ink",
    bar: "#d6eaf4",
    barInk: "#0b1d2b",
    tone: "light",
    preview: { case: "#d6eaf4", tube: "#0a6aa8", ink: "#0b1d2b" }
  },
  {
    id: "matcha",
    group: "nature",
    label: "matcha",
    blurb: "soft green tea and a dark leaf",
    bar: "#d9e3c6",
    barInk: "#1d2a12",
    tone: "light",
    preview: { case: "#d9e3c6", tube: "#3d6b1f", ink: "#1d2a12" }
  },
  {
    id: "redroom",
    group: "edge",
    label: "redroom",
    blurb: "the otherworld: rust black and blood red",
    bar: "#0a0505",
    barInk: "#ff3340",
    tone: "dark",
    preview: { case: "#0a0505", tube: "#ff3340", ink: "#b9a39b" }
  },
  {
    id: "neon",
    group: "edge",
    label: "neon",
    blurb: "night city chrome, warning yellow, red glitch",
    bar: "#07070a",
    barInk: "#fcee0a",
    tone: "dark",
    preview: { case: "#07070a", tube: "#fcee0a", ink: "#ff003c" }
  },
  {
    id: "venom",
    group: "edge",
    label: "venom",
    blurb: "bruise purple fog and acid lime",
    bar: "#08060c",
    barInk: "#c6ff00",
    tone: "dark",
    preview: { case: "#08060c", tube: "#c6ff00", ink: "#b3a9c2" }
  },
  {
    id: "mono",
    group: "edge",
    label: "mono",
    blurb: "pure black and white, no mercy",
    bar: "#000000",
    barInk: "#ffffff",
    tone: "dark",
    preview: { case: "#000000", tube: "#ffffff", ink: "#b5b5b5" }
  },
  {
    id: "phosphor",
    group: "retro",
    label: "phosphor",
    blurb: "green crt, memory card manager at 2am",
    bar: "#030a05",
    barInk: "#3dff7f",
    tone: "dark",
    preview: { case: "#030a05", tube: "#3dff7f", ink: "#86d49d" }
  },
  {
    id: "amber",
    group: "retro",
    label: "amber",
    blurb: "amber crt terminal, warm glow",
    bar: "#0b0702",
    barInk: "#ffb000",
    tone: "dark",
    preview: { case: "#0b0702", tube: "#ffb000", ink: "#d9a866" }
  },
  {
    id: "flipnote",
    group: "retro",
    label: "flipnote",
    blurb: "cream sketch paper and flipnote orange",
    bar: "#ece2cc",
    barInk: "#1f1a14",
    tone: "light",
    preview: { case: "#ece2cc", tube: "#b83c0a", ink: "#1f1a14" }
  },
  {
    id: "psx",
    group: "retro",
    label: "psx",
    blurb: "grey console, blue memory card screen",
    bar: "#c4c4cc",
    barInk: "#15151c",
    tone: "light",
    preview: { case: "#c4c4cc", tube: "#2340b8", ink: "#3a3a48" }
  },
  {
    id: "vapor",
    group: "retro",
    label: "vapor",
    blurb: "late night mall, pink on purple with a cyan edge",
    bar: "#10062a",
    barInk: "#ff71ce",
    tone: "dark",
    preview: { case: "#10062a", tube: "#ff71ce", ink: "#01cdfe" }
  },
  {
    id: "bsod",
    group: "retro",
    label: "bsod",
    blurb: "a blue screen, white text, nothing to hide",
    bar: "#0a1a8c",
    barInk: "#ffffff",
    tone: "dark",
    preview: { case: "#0a1a8c", tube: "#ffffff", ink: "#c4cbff" }
  },
  {
    id: "blueprint",
    group: "retro",
    label: "blueprint",
    blurb: "cyan ink on drafting blue",
    bar: "#0c3b6e",
    barInk: "#9fe0ff",
    tone: "dark",
    preview: { case: "#0c3b6e", tube: "#9fe0ff", ink: "#aedcf5" }
  },
  {
    id: "dsi",
    group: "retro",
    label: "dsi",
    blurb: "glossy white handheld and its blue menu",
    bar: "#e4e8ee",
    barInk: "#1a2230",
    tone: "light",
    preview: { case: "#e4e8ee", tube: "#0b7bc0", ink: "#1a2230" }
  },
  {
    id: "pocket",
    group: "retro",
    label: "pocket",
    blurb: "four shades of handheld green",
    bar: "#c9d19b",
    barInk: "#1e2a10",
    tone: "light",
    preview: { case: "#c9d19b", tube: "#306230", ink: "#3a4a22" }
  },
  {
    id: "rust",
    group: "otherworld",
    label: "otherworld rust",
    blurb: "peeling paint and a rusted siren",
    bar: "#1a0f0c",
    barInk: "#b5502d",
    tone: "dark",
    preview: { case: "#1a0f0c", tube: "#b5502d", ink: "#bbaa9f" }
  },
  {
    id: "hospital",
    group: "otherworld",
    label: "hospital green",
    blurb: "flickering corridor light, sick green tile",
    bar: "#0c1512",
    barInk: "#5fa58b",
    tone: "dark",
    preview: { case: "#0c1512", tube: "#5fa58b", ink: "#a8b6b0" }
  },
  {
    id: "aqua",
    group: "y2k",
    label: "y2k aqua",
    blurb: "glossy bubble blue, 2001 desktop",
    bar: "#d9f3ff",
    barInk: "#06283a",
    tone: "light",
    preview: { case: "#d9f3ff", tube: "#2282ab", ink: "#3b5b6b" }
  },
  {
    id: "vhs",
    group: "retro",
    label: "vhs blue",
    blurb: "tracking lines and a blue no signal screen",
    bar: "#0a0f3a",
    barInk: "#3566f2",
    tone: "dark",
    preview: { case: "#0a0f3a", tube: "#3566f2", ink: "#b1b5ce" }
  },
  {
    id: "zine",
    group: "retro",
    label: "paper zine",
    blurb: "photocopied paper and red marker",
    bar: "#f2ecdf",
    barInk: "#1a1612",
    tone: "light",
    preview: { case: "#f2ecdf", tube: "#d4283a", ink: "#504c45" }
  },
  {
    id: "cassette",
    group: "retro",
    label: "cassette",
    blurb: "walkman amber, warm brown tape",
    bar: "#1c1410",
    barInk: "#ff8a2a",
    tone: "dark",
    preview: { case: "#1c1410", tube: "#ff8a2a", ink: "#bdaf9f" }
  },
  {
    id: "moonlit",
    group: "sweet",
    label: "moonlit violet",
    blurb: "a quiet night in lavender light",
    bar: "#0e0a1f",
    barInk: "#a99bff",
    tone: "dark",
    preview: { case: "#0e0a1f", tube: "#a99bff", ink: "#b2aec7" }
  },
  {
    id: "lime",
    group: "y2k",
    label: "lime soda",
    blurb: "fizzy lime, bright sticker shop",
    bar: "#f4ffd9",
    barInk: "#1a2a06",
    tone: "light",
    preview: { case: "#f4ffd9", tube: "#509516", ink: "#515f3b" }
  },
  {
    id: "quartz",
    group: "sweet",
    label: "rose quartz",
    blurb: "pale pink stone and soft rose",
    bar: "#ffeef2",
    barInk: "#2f1420",
    tone: "light",
    preview: { case: "#ffeef2", tube: "#c55d79", ink: "#634b55" }
  },
  {
    id: "sepia",
    group: "retro",
    label: "sepia archive",
    blurb: "old film stock and brown ink",
    bar: "#e9dcc3",
    barInk: "#2a1a0c",
    tone: "light",
    preview: { case: "#e9dcc3", tube: "#8a5a2b", ink: "#5a4b3a" }
  },
  {
    id: "deepsea",
    group: "nature",
    label: "deep sea lab",
    blurb: "bathyscaphe lights and bioluminescent teal",
    bar: "#02101a",
    barInk: "#19c3a8",
    tone: "dark",
    preview: { case: "#02101a", tube: "#19c3a8", ink: "#a1b8bb" }
  },
  {
    id: "arcadenight",
    group: "y2k",
    label: "arcade night",
    blurb: "cabinet glow, hot pink and electric cyan",
    bar: "#0b0016",
    barInk: "#ff2e97",
    tone: "dark",
    preview: { case: "#0b0016", tube: "#ff2e97", ink: "#b8aec5" }
  },
  {
    id: "velvet",
    group: "mature",
    label: "velvet room",
    blurb: "wine velvet curtains and low red light",
    bar: "#12040a",
    barInk: "#ff4d7d",
    tone: "dark",
    mature: true,
    preview: { case: "#12040a", tube: "#ff4d7d", ink: "#bdabaf" }
  },
  {
    id: "boudoir",
    group: "mature",
    label: "boudoir",
    blurb: "dusty rose, silk and brass lamplight",
    bar: "#1e0f16",
    barInk: "#e8a0b4",
    tone: "dark",
    mature: true,
    preview: { case: "#1e0f16", tube: "#e8a0b4", ink: "#bfb0b4" }
  },
  {
    id: "latex",
    group: "mature",
    label: "latex noir",
    blurb: "wet black gloss and a red sliver",
    bar: "#050506",
    barInk: "#ff2b4a",
    tone: "dark",
    mature: true,
    preview: { case: "#050506", tube: "#ff2b4a", ink: "#b2b2b7" }
  },
  {
    id: "loungeneon",
    group: "mature",
    label: "neon lounge",
    blurb: "magenta tubes in a smoky bar",
    bar: "#0a0614",
    barInk: "#ff3df0",
    tone: "dark",
    mature: true,
    preview: { case: "#0a0614", tube: "#ff3df0", ink: "#bab0c4" }
  },
  {
    id: "succubus",
    group: "mature",
    label: "succubus",
    blurb: "blood red, violet shadow, a wicked grin",
    bar: "#0f0408",
    barInk: "#ff1f4b",
    tone: "dark",
    mature: true,
    preview: { case: "#0f0408", tube: "#ff1f4b", ink: "#baa8ad" }
  },
  {
    id: "honeytrap",
    group: "mature",
    label: "honey trap",
    blurb: "warm amber, sticky gold and candle smoke",
    bar: "#1a1004",
    barInk: "#ffb627",
    tone: "dark",
    mature: true,
    preview: { case: "#1a1004", tube: "#ffb627", ink: "#c3b7a0" }
  },
  {
    id: "cherrycola",
    group: "mature",
    label: "cherry cola",
    blurb: "dark fizz, cherry red, diner neon",
    bar: "#1a0508",
    barInk: "#ff3b4e",
    tone: "dark",
    mature: true,
    preview: { case: "#1a0508", tube: "#ff3b4e", ink: "#c1aca7" }
  },
  {
    id: "afterhours",
    group: "mature",
    label: "after hours",
    blurb: "midnight indigo and rose city lights",
    bar: "#0b0d1c",
    barInk: "#b794ff",
    tone: "dark",
    mature: true,
    preview: { case: "#0b0d1c", tube: "#b794ff", ink: "#b1b0bf" }
  }
];

export const DEFAULT_THEME_ID = "night";

// themes from before the signal redesign land on the closest one
const LEGACY: Record<string, string> = { putty: "fog", holo: "fog", "night-deck": "night", scrap: "redroom" };

export function themeById(id: string): ThemeInfo {
  const wanted = LEGACY[id] || id;
  return THEMES.find((theme) => theme.id === wanted) || THEMES[0];
}

export function themeIsLight(id: string): boolean {
  return themeById(id).tone === "light";
}

// a faint pattern behind everything, drawn in the theme's own line colour so it fits any theme
export interface PatternInfo {
  id: string;
  label: string;
  // drawn on a canvas and moving, the rest are still css
  animated?: boolean;
}

export const PATTERNS: PatternInfo[] = [
  { id: "none", label: "none" },
  { id: "scan", label: "scanlines" },
  { id: "grid", label: "grid" },
  { id: "dots", label: "dots" },
  { id: "lined", label: "notebook" },
  { id: "checker", label: "checker" },
  { id: "plus", label: "crosshair" },
  { id: "stars", label: "sparkles" },
  { id: "hazard", label: "hazard" },
  { id: "waves", label: "waves" },
  { id: "hex", label: "honeycomb" },
  { id: "diamonds", label: "diamonds" },
  { id: "cross", label: "cross stitch" },
  { id: "starfield", label: "starry sky", animated: true },
  { id: "leaves", label: "falling leaves", animated: true },
  { id: "petals", label: "sakura petals", animated: true },
  { id: "snow", label: "snow", animated: true },
  { id: "rain", label: "rain", animated: true },
  { id: "fireflies", label: "fireflies", animated: true },
  { id: "embers", label: "embers", animated: true },
  { id: "bubbles", label: "bubbles", animated: true },
  { id: "matrix", label: "code rain", animated: true }
];

export const DEFAULT_PATTERN_ID = "none";

export function patternById(id: string): PatternInfo {
  return PATTERNS.find((pattern) => pattern.id === id) || PATTERNS[0];
}
